import React, { Component, Fragment } from 'react'

import BrancheHeader from '../../components/BrancheHeader/'
import { ChevronThinRight } from '../../components/Icons'

import { Container, Bar, BarItem, Meta, Branch, Sup, MetaContainer, IconContainer } from './styles'

class BrancheList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filteredBranches: []
    }
  }

  componentDidMount() {
    this.setState({ filteredBranches: this.props.branches })
  }

  onSearch(e) {
    let query = e.target.value.trim().toLowerCase()
    let queryLength = e.target.value.length

    const result =
      queryLength === 0
        ? []
        : this.props.branches.filter(
            branch =>
              branch.name.toLowerCase().slice(0, queryLength) === query ||
              branch.address.toLowerCase().slice(0, queryLength) === query ||
              branch.zipcode.toLowerCase().slice(0, queryLength) === query ||
              branch.city.toLowerCase().slice(0, queryLength) === query
          )

    if (result.length > 0) {
      this.setState({ filteredBranches: result })
    } else {
      this.setState({ filteredBranches: this.props.branches })
    }
  }

  handleClick(e) {
    this.props.handleClick(e.currentTarget.dataset.branch)
  }

  render() {
    let sups = ['naam', 'adres', 'postcode', 'plaats']

    return (
      <Container>
        <BrancheHeader dark={this.props.dark} title={this.props.title} onSearch={this.onSearch.bind(this)} />

        <Fragment>
          <Bar>
            <BarItem dark={this.props.dark}>Naam</BarItem>
            <BarItem dark={this.props.dark}>Adres</BarItem>
            <BarItem dark={this.props.dark}>Postcode</BarItem>
            <BarItem dark={this.props.dark}>Plaats</BarItem>
          </Bar>

          {this.state.filteredBranches.map((branch, index) => {
            return (
              <Branch
                selected={this.props.selectedBranch === branch.id}
                onClick={this.props.selectedBranch === branch.id ? null : this.handleClick.bind(this)}
                data-branch={branch.id}
                key={index}
              >
                {Object.keys(branch).map((key, index) => {
                  if (key !== 'id' && key !== '__typename' && key !== 'servicePackage') {
                    return (
                      <MetaContainer key={index}>
                        <Sup selected={this.props.selectedBranch === branch.id}>{sups[index]}</Sup>
                        <Meta>{branch[key]}</Meta>
                      </MetaContainer>
                    )
                  }
                  return null
                })}
                <IconContainer>
                  <ChevronThinRight size="" />
                </IconContainer>
              </Branch>
            )
          })}
        </Fragment>
      </Container>
    )
  }
}

export default BrancheList



// WEBPACK FOOTER //
// ./src/containers/BrancheList/index.js